import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Avatar/Avatar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Breadcrumbs/Breadcrumbs.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Link/Link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogHero/BlogTags/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogHero/BlogAuthor/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogHero/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogBody/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogBody/raw-html-styles.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogPostTags/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BlogTagsFooter/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog/BlogPost/BreadcrumbsRow/share-this.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blog/BlogPost/RelatedBlogs/related-blogs-carousel/related-blogs-carousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/RelatedBlogs/RelatedBlogs.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/blog/BlogPost/BreadcrumbsRow/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CircularPlayButton"] */ "/app/src/components/shared/wistia-video/circular-play-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WistiaPlayButton"] */ "/app/src/components/shared/wistia-video/wistia-play-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/shared/wistia-video/wistia-video.tsx");
